<template>
  <div class="row">
    <div class="col-xs-12">
      <h1 class="text-primary">
        <small>Administration</small>
        <br>
        Jeux de données
      </h1>
      <hr>
    </div>
    <div class="col-xs-12">
      <div class="panel panel-info">
        <div class="panel-heading">
          <div class="form-inline">
            <div class="form-group">
              <btn type="warning" @click="migrate"
                   :disabled="computeDatasetStatus.running">
                Migrer les surveillances 2019
              </btn>
            </div>
            <div class="form-group">
              <btn type="warning" @click="observa42020"
                   :disabled="computeDatasetStatus.running">
                Constituer le jeu de données SPIADI2020 pour observa4
              </btn>
            </div>
            <div class="form-group">
              <btn type="warning" @click="updateAllDatasets"
                   :disabled="computeDatasetStatus.running">
                Re-calculer les résultats pour tous les jeux de données (Journaliers et personnalisés)
              </btn>
            </div>
            <div v-if="computeDatasetStatus.running">
              <br>
              <div class="progress">
                <div class="progress-bar"
                     role="progressbar"
                     :style="`width: ${computeDatasetStatus.pct}%`"
                     :aria-valuenow="computeDatasetStatus.pct"
                     aria-valuemin="0"
                     aria-valuemax="100">
                  <span v-if="computeDatasetStatus.pct > 6">{{progressStatus}}</span>
                </div>
              </div>
              Le calcul des incidences est en cours pour tous les jeux de données.
              <span v-if="computeDatasetStatus.pct <= 6"> {{progressStatus}}</span>
              <div>
                Tâches en attente : {{ computeDatasetStatus.waiting }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-for="(y, k) in years"
         :key="k" class="col-xs-12 col-md-4">
      <div class="panel panel-primary">
        <div class="panel-heading">
          <div class="panel-title">
            <h4><strong>{{ k }}</strong></h4>
          </div>
        </div>
        <div class="panel-body">
          <div v-for="(t, i) in y" :key="t">
            <hr v-if="i > 0">
            <h5>
              <strong class="txt-primary">
                {{ t }}
              </strong>
            </h5>
            <div class="actions">
              <div v-if="t.match(/SPIADI20[0-9]{2}($|-SURV-)/) != null">
                <btn type="info"
                     :disabled="computeDatasetStatus.running"
                     @click="generateInfections(k, t, 'bact')"
                     size="sm">
                  <strong>Bactériémies</strong>
                </btn>
                <btn type="info"
                     :disabled="computeDatasetStatus.running"
                     @click="generateInfections(k, t, 'pneu')"
                     size="sm">
                  <strong>Pneumopathies</strong>
                </btn>
                <btn type="warning"
                     :disabled="computeDatasetStatus.running"
                     @click="generateDenominators(t)"
                     size="sm">
                  <strong>Dénominateurs</strong>
                </btn>
                <btn type="success"
                     :disabled="computeDatasetStatus.running"
                     @click="generateIncidences(k, t)"
                     size="sm">
                  <strong>Incidences</strong>
                </btn>
              </div>
              <div v-if="t.match(/-/) !== null">
                <btn type="danger"
                     @click="remove(t)"
                     size="sm"
                     :disabled="computeDatasetStatus.running">
                  Supprimer
                </btn>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer" v-if="fixButtons[k].hasButton">
          <div class="row">
            <div  v-if="fixButtons[k].surv"
                  :class="`col-xs-12 col-md-${fixButtons[k].width}`">
              <btn class="btn-bactADI" @click="add(k, 'surv')" block>
                Ajouter <br>(Surveillance)
              </btn>
            </div>
            <div  v-if="fixButtons[k].obs"
                  :class="`col-xs-12 col-md-${fixButtons[k].width}`">
              <btn class="btn-observa4" @click="add(k, 'obs')" block>
                Ajouter <br>({{obsModulesDisplay[k]}})
              </btn>
            </div>
            <div  v-if="fixButtons[k].causes"
                  :class="`col-xs-12 col-md-${fixButtons[k].width}`" >
              <btn class="btn-badiCause" @click="add(k, 'causes')" block>
                Ajouter <br>(BadiCAUSE)
              </btn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import assert from '@/sui/tools/assert'
import { confirm } from '@/sui/tools/modal'
import { mapState } from 'vuex'

function sleep (ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export default {
  name: 'datasets',

  data: function () {
    return {
      computeDatasetStatus: {
        running: false,
        info: 0,
        total: 0,
        pct: 0,
        waiting: 0
      }
    }
  },

  mounted: function () {
    this.loadNames()
    this.getUpdateDsetsStatus()
  },

  computed: {
    progressStatus: function () {
      const c = this.computeDatasetStatus
      return `${c.pct.toFixed(0)} % (${c.info} / ${c.total})`
    },

    ...mapState({
      years: state => state.dataset.names.values
    }),

    availableYearsList: function () {
      const ys = this.years
      return ys != null ? Object.keys(ys) : []
    },

    fixButtons: function () {
      const ys = this.availableYearsList
      const result = {}
      for (let i = 0; i < ys.length; i++) {
        const y = ys[i]
        const intY = parseInt(y)
        const hasSurv = intY > 2019
        const hasObs = intY > 2020
        const hasCauses = intY > 2025

        result[y] = {
          surv: hasSurv,
          obs: hasObs,
          causes: hasCauses,
          hasButton: hasSurv || hasObs || hasCauses,
          width: 12 / (hasSurv + hasObs + hasCauses)
        }
      }
      return result
    },

    obsModulesDisplay: function () {
      const ys = this.availableYearsList
      const result = {}
      for (let i = 0; i < ys.length; i++) {
        const y = ys[i]
        result[y] = y > 2025 ? 'Observa4, Spy4' : 'Observa4'
      }
      return result
    }
  },

  methods: {
    getModulesAndDatasetPrefix: function (y, type) {
      if (type === 'surv') {
        return {
          list: ['bactADI', 'reaInfADI', 'expADI', 'diaInfADI', 'neoInfADI'],
          prefix: 'SURV',
          areSurv: true
        }
      }

      if (type === 'obs') {
        if (y > 2025) {
          return {
            list: ['observa4', 'spy4'],
            prefix: 'OBSP'
          }
        }
        return {
          list: ['observa4'],
          prefix: 'OBS4'
        }
      }

      assert(type === 'causes')
      return {
        list: ['badiCause'],
        prefix: 'CAUSE'
      }
    },

    observa42020: function () {
      this.$store.dispatch('surveillances/o4dataset2020')
    },

    updateAllDatasets: function () {
      this.$store.dispatch('dataset/computeAllDatasetsResults')
    },

    getUpdateDsetsStatus: async function () {
      const c = this.computeDatasetStatus

      do {
        this.$store.dispatch(
          `dataset/isDatasetComputing`
        ).then(
          (response) => {
            const d = response.data
            c.running = d.running
            c.info = d.count
            c.total = d.total
            c.pct = d.count / d.total * 100
            c.waiting = d.waiting
          }
        ).catch(e => {
          this.setError(e)
          c.running = false
          c.info = 0
          c.total = 0
          c.pct = 0
          c.waiting = 0
        })

        await sleep(2000)
      } while (true)
    },

    migrate: function () {
      this.$store.dispatch('surveillances/migrate')
    },

    loadNames: function () {
      this.$store.dispatch('dataset/allSpiadiNames').then(
        r => {
          if (r.data.err != null) {
            this.setError(
              r.data.err,
              `Une erreur est survenue lors de la récupération des noms des
jeux de données`
            )
          }
        }
      )
    },

    setError: function (err, msg) {
      const pattern = msg == null
        ? `Une erreur est survenue lors de l'exécution du traitement :`
        : msg
      this.$notify({
        type: 'danger',
        title: 'Erreur !',
        content: `${pattern} : ${err}`
      })
    },

    run: function (event, request) {
      const vm = this
      vm.$store.dispatch(event, request).then(
        (response) => {
          if (response.data.err != null) {
            vm.setError(response.data.err)
          }
        }
      ).catch(e => {
        vm.setError(e)
      })
    },

    generateDenominators: function (dataset) {
      const request = { name: dataset }
      this.run('dataset/transform', request)
    },

    generateIncidences: function (year, dataset) {
      const request = { y: parseInt(year), d: dataset }
      this.run('incidences/compute', request)
    },

    generateInfections: function (year, dataset, infection) {
      const request = { y: parseInt(year), ds: dataset, inf: infection }
      this.run('infections/transform', request)
    },

    add: function (year, modType) {
      const intY = parseInt(year)
      const modules = this.getModulesAndDatasetPrefix(intY, modType)
      const request = {
        y: intY,
        m: modules.list,
        p: modules.prefix
      }
      const event = modules.areSurv ? 'incidences/freeze' : 'dataset/copy'
      confirm(
        this,
        `
Êtes-vous sûr.e de vouloir ajouter un jeu de donnée pour l'année ${year} ?
<br><br>
Ce jeu de donnée sera constitué avec les données actuelles figées.
        `
      ).then(
        () => {
          this.$store.dispatch(event, request).then(
            r => {
              if (r.data.err == null) {
                this.loadNames()
              } else {
                this.setError(r.data.err)
              }
              return r
            }
          ).catch(
            (e) => { this.setError(e) }
          )
        }
      ).catch(() => {})
    },

    remove: function (name) {
      confirm(
        this,
        `
Êtes-vous sûr.e de vouloir supprimer le jeu de donnée «${name}» ?
       `
      ).then(
        () => {
          this.run('dataset/removeByName', { name: name })
        }
      ).catch(
        () => {}
      )
    }
  }
}
</script>
<style lang="less" scoped>
.actions {
  .btn {
    margin-right: 1rem;
    margin-bottom: 0.5rem;
  }
}

.panel-body {
  hr {
    margin: 10px 0px;
  }
}

.progress .txt-dark {
  color: #3ca5af;
}

.progress .txt-white {
  color: #ffffff;
}

</style>
